import { FC, PropsWithChildren } from 'react'
import { Col, ColProps, Row, RowProps } from 'antd'
import { RouteHeader } from '@molecules/routeHeader'
import { TRoutesTree } from 'types/routes'


const Layout: FC<RowProps> = ({children, ...props}) => (
    <Row style={{width: '100%'}} {...props}>{children}</Row>
)

const LayoutHeader: FC<ColProps> = ({children, ...props}) => (
    <Col span={24} {...props}>{children}</Col>
)

const LayoutContent: FC<ColProps> = ({children, ...props}) => (
    <Col span={24} style={{padding: '10px'}} {...props}>{children}</Col>
)

export const BaseWrapper = ({ children, routesTree }: PropsWithChildren<{
    routesTree: TRoutesTree
}>) => {    
    return (
        <Layout>
            <LayoutHeader>
                <RouteHeader routesTree={routesTree} />
            </LayoutHeader>
            <LayoutContent>
                {children}
            </LayoutContent>
        </Layout>
    )
}
